var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m769.5 75h-338.63c-124.13 0-225 100.88-225 225v750c0 30.375 18 57.375 46.125 69s60 5.25 81.75-16.125l266.63-266.63 266.63 266.63c14.25 14.25 33.375 21.75 52.875 21.75 9.75 0 19.5-1.875 28.875-5.625 28.125-11.625 46.125-38.625 46.125-69v-750c0-124.13-100.88-225-225-225zm150 975-266.63-266.63c-28.125-28.125-77.625-28.125-105.75 0l-266.26 266.63v-750c0-82.875 67.125-150 150-150h338.63c82.875 0 150 67.125 150 150z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutline);
export default __webpack_public_path__ + "static/media/bookmark-outline.03c4447f62d51e93eccbe8d09fe365d0.svg";
export { ForwardRef as ReactComponent };